import { Space } from "antd";
import React, { useState } from "react";
import { ButtonUi } from "../../ui/ButtonUi";
import { TipoButtonConstants } from "../../../types/typesConstants";
import { TagRowTable } from "../../../helpers/utils";
import { usuarioSetActive, usuarioStartDelete } from "../../../actions/usuario";
import { useDispatch } from "react-redux";
import { showDeleteConfirm } from "../../../helpers/confirmModal";
import { TableSearchBasicUi } from "../../ui/TableSearchBasicUi";

const columns = (acciones) => [
  {
    title: "N°",
    dataIndex: "index",
    key: "index",
    render: (text, record, index) => <>{index + 1}</>,
  },
  {
    title: "Username",
    dataIndex: "username",
    key: "username",
    filteredValue: [acciones?.filteredColumn],
    onFilter: (value, record) =>
      String(record?.username).toLowerCase().includes(value.toLowerCase()) ||
      String(record?.first_name).toLowerCase().includes(value.toLowerCase()) ||
      String(record?.last_name).toLowerCase().includes(value.toLowerCase()),
  },
  {
    title: "Nombres",
    dataIndex: "first_name",
    key: "first_name",
  },
  {
    title: "Apellidos",
    dataIndex: "last_name",
    key: "last_name",
  },
  {
    title: "¿Es Super Usuario?",
    dataIndex: "is_superuser",
    key: "is_superuser",
    render: (text) => <TagRowTable estado={text} />,
  },
  {
    title: "¿Esta activo?",
    dataIndex: "is_active",
    key: "is_active",
    render: (text) => <TagRowTable estado={text} />,
  },
  {
    title: "Acciones",
    dataIndex: "acciones",
    key: "acciones",
    render: (text, record) => (
      <Space size="middle">
        <ButtonUi
          typeUi={TipoButtonConstants.EditarTable}
          onClick={() => acciones.handleEditar(record)}
          displayText={false}
        ></ButtonUi>
        <ButtonUi
          typeUi={TipoButtonConstants.EliminarTable}
          onClick={() => acciones.handleEliminar(record)}
          displayText={false}
        ></ButtonUi>
      </Space>
    ),
  },
];
export const UsuarioTable = ({ usuarios, loading, handleOpenForm }) => {
  const dispatch = useDispatch();
  const [searchText, setSearchText] = useState("");
  const handleEditar = (usuario) => {
    dispatch(usuarioSetActive(usuario));
    handleOpenForm();
  };
  const handleEliminar = (usuario) => {
    showDeleteConfirm(
      "¿Está seguro de eliminar el usuario seleccionado?",
      usuario.username,
      (isConfirmed) => {
        if (isConfirmed) {
          dispatch(usuarioStartDelete(usuario));
        }
      }
    );
  };
  const onSearch = (value) => {
    setSearchText(value);
  };
  return (
    <TableSearchBasicUi
      data={usuarios}
      columns={columns({
        filteredColumn: searchText,
        handleEditar,
        handleEliminar,
      })}
      loading={loading}
      onSearch={onSearch}
      size="small"
      rowKey="id"
    />
  );
};
